import { Component, Input, OnInit } from '@angular/core';
import { NavBreadcrumb } from '@models/models';

@Component({
	selector: 'setting-section-header',
	template: require('./setting-section-header.html'),
	styles: [require('./setting-section-header.scss')]
})
export class SettingSectionHeaderComponent implements OnInit {
	@Input() breadcrumbs: Array<NavBreadcrumb>;

	title: string;
	constructor() {}

	ngOnInit(): void {
		this.title = this.breadcrumbs[this.breadcrumbs.length - 1].title;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/settings/common/setting-section-header/setting-section-header.ts